var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"group-bar",class:{ selected: _vm.isTargetGroupContentOpened(_vm.group.documentId) },style:('--color:' +
      _vm.group.color +
      ';' +
      '--hover:' +
      _vm.getHoverColor(_vm.group.color) +
      ';'),on:{"click":function($event){return _vm.switchGroupContent(_vm.group.documentId)}}},[_c('span',{staticClass:"group-name truncate",style:({ '--color': _vm.group.color })},[_vm._v(_vm._s(_vm.group.label))]),_c('span',{staticClass:"content-length",style:('background:' + _vm.group.color + ';')},[_vm._v(_vm._s(_vm.group.vessels.length))]),_c('div',{staticClass:"group-bar-background"})])])}
var staticRenderFns = []

export { render, staticRenderFns }